<div class="iframe-wrapper" *ngIf="instagramPromotionData">
  <iframe
    *ngIf="instagramPromotionData.link"
    class="instagram-embedded-iframe"
    [src]="instagramPromotionData.link | instagramEmbeddedLink | safeLink: 'resourceUrl'"></iframe>
  <div *ngIf="!instagramPromotionData.link" class="instagram-preview">
    <common-instagram-preview-icon></common-instagram-preview-icon>
    <div class="preview-title">Instagram will appear here</div>
  </div>
</div>
